<template>
    <div class="c-modal-wrapper c-gray-back">
      <!-- Application Header -->
      <!-- <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
            </div>            
            <div class="c-modal-info-title"><b>Rezervacije title</b></div>
          </div>
        </div>
      </header> -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>      
      <!-- Body content -->
      <div class="c-modal-body c-to-full-bottom c-has-skewed-background">
        <div class="c-responsive-container">
          <div v-if="eventBasicInfo">
            <!-- Basic info of Event -->
            <div class="c-event-details-block">
              <div class="c-has-event-title"><b>{{eventBasicInfo.eventName}}</b></div>
              <div class="c-has-small-details">
                <span v-if="eventBasicInfo.eventDate">{{returnEventDate_fullDate(eventBasicInfo)}}</span>
                <span v-if="eventBasicInfo.eventVenue">- {{returnEventVenue_type(eventBasicInfo)}}</span>
                <span v-if="eventBasicInfo.ticketPrice">- Ulaz: {{eventBasicInfo.ticketPrice}} {{returnCurrencyType(eventBasicInfo)}}</span>
              </div>
            </div>
            <!-- Section Title -->
            <div class="c-event-tables-title-box">Lista rezervacija za ovaj dogadjaj</div>
            <!-- List of all tables for event -->
            <transition name="fade" mode="out-in">
              <div v-if="isLoading.length == 0">
                <ul class="c-items-list" v-if="listOfReservationsForEvent">
                  <li class="c-single-event-reservation" 
                  v-for="(singleReservationItem, itemIndex) in listOfReservationsForEvent"
                  v-bind:class="returnTableCheckinClass(singleReservationItem)"
                  >
                    <table class="c-content-as-table">
                      <tbody>
                        <tr>
                          <!-- Date -->
                          <td class="c-has-table-number">
                              <!-- Table number -->
                              <span v-if="singleReservationItem.tableShortName && singleReservationItem.tableNumber"><b>{{singleReservationItem.tableShortName}}{{singleReservationItem.tableNumber}}</b></span>
                              <span v-else>Err</span>
                          </td>
                          <!-- Text content -->
                          <td class="c-has-guest-name">
                            <div v-if="singleReservationItem.guestFirstName || singleReservationItem.guestLastName || singleReservationItem.guestNickname">
                              <span v-if="singleReservationItem.guestFirstName"><b>{{singleReservationItem.guestFirstName}}</b></span>
                              <span v-if="singleReservationItem.guestLastName"><b>{{singleReservationItem.guestLastName}}</b></span>
                              <span v-if="singleReservationItem.guestNickname"><b>{{singleReservationItem.guestNickname}}</b></span>                        
                            </div>
                            <div v-else>Empty</div>
                          </td>
                          <!-- Action buttons -->
                        </tr>
                      </tbody>
                    </table>
                    <!-- Action buttons -->
                    <div class="c-has-buttons">
                      <div v-if="calculateIfTableIsLocked(singleReservationItem)">
                        <button class="c-btn c-btn-action-on-white" v-on:click="checkLockTableStatus(singleReservationItem)"><i class="fa fa-lock c-ux-color-danger" aria-hidden="true"></i></button>
                        <button class="c-btn c-btn-action-on-white" v-if="calculateUserEditPermision(singleReservationItem)" v-on:click="openReservationDetails(singleReservationItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      </div>
                      <div v-else>
                        <button class="c-btn c-btn-action-on-white" v-on:click="toggleExpandReservationButtonOptions(singleReservationItem.uid)"><i class="fa fa-bars" aria-hidden="true"></i></button>
                        <button class="c-btn c-btn-action-on-white" v-on:click="openReservationDetails(singleReservationItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      </div>
                    </div>
                    <!-- Expanded buttons -->
                    <transition name="slide-left" mode="out-in">
                      <div class="c-expanded-button-options" v-if="expandedOptionsIndex == singleReservationItem.uid">
                        <div class="c-has-txt"><span>Dodatne opcije</span></div>
                        <div class="c-has-buttons">
                          <!-- Lock table -->
                          <button class="c-btn c-btn-action-on-white" 
                          v-if="glMixin_userAccessCheck(currentFirebaseUser, 9)"
                          v-on:click="openLockTable(singleReservationItem)"><i class="fa fa-lock" aria-hidden="true"></i><span class="c-has-title">Zaključaj</span></button>
                          <!-- Swap table -->
                          <button class="c-btn c-btn-action-on-white" v-on:click="openSwapReservations(singleReservationItem)"><i class="fa fa-retweet" aria-hidden="true"></i><span class="c-has-title">Zameni</span></button>
                          <!-- Checkin status -->
                          <button v-if="singleReservationItem.guestFirstName || singleReservationItem.guestLastName || singleReservationItem.guestNickname" 
                            class="c-btn c-btn-action-on-white" v-on:click="openCheckinStatus(singleReservationItem)">
                            <i class="fa fa-bell" aria-hidden="true"></i>
                            <span class="c-has-title">Čekiraj</span>
                          </button>
                          <!-- Close additinal options -->
                          <button class="c-btn c-btn-action-on-white" v-on:click="toggleExpandReservationButtonOptions(singleReservationItem.uid)"><i class="fa fa-times" aria-hidden="true"></i></button>
                        </div>
                      </div>
                    </transition>
                  </li>
                </ul>
                <div v-else><b>Nothing to show</b></div>
              </div>
            </transition>
          </div>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-8 c-align-right">            
            </div>
            <div class="c-col-4 c-align-right">
              <button class="c-btn c-btn-primary" v-on:click="toggleReservationsPlan()"><i class="fa fa-file-image-o" aria-hidden="true"></i> <b>Raspored stolova</b></button>
            </div>
          </div>
        </div>
      </footer>
      <!-- Modal Templates -->
      <transition name="slide-up" mode="out-in">
        <component 
          v-if="modalComponent.isVisible" 
          v-bind:is="modalComponent.activeModalComponent"
          v-bind:input-modal-data = "modalComponent.dataForModal"
        ></component>
      </transition>
      <!-- Reservation Table plan image -->
      <transition name="slide-up" mode="out-in">
        <div class="c-modal-wrapper" v-if="reservationsImage.isVisible">
          <header class="c-modal-header">
            <div class="c-responsive-container">
              <div class="c-as-block c-has-header-buttons">
                <div class="c-grid-row">
                  <div class="c-col-12">
                    <button class="c-btn" v-on:click="toggleReservationsPlan()"><i aria-hidden="true" class="fa fa-times"></i> <b>Zatvori</b></button>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div class="c-modal-body c-to-full-bottom c-has-tables-map-image" style="text-align:center;background-color:#fff;">
            <img style="height:100%;width:auto;" :src="reservationsImage.imgUrl" alt="Plan rezervacija">
          </div>
        </div>
      </transition>      
    </div>
</template>

<script>
import router from "@/router/index";
import EventBus from "@/EventBus";
import ModalSingleReservation from "@/components/futureEvents/ModalSingleReservation";
import ModalQuickLock from "@/components/futureEvents/ModalQuickLock";
import ModalQuickShowWhoLockedTable from "@/components/futureEvents/ModalQuickShowWhoLockedTable";
import ModalQuickSwapReservations from "@/components/futureEvents/ModalQuickSwapReservations";
import ModalQuickCheckin from "@/components/futureEvents/ModalQuickCheckin";
import moment from "moment";
import { firebaseDB } from "@/firebase";
export default {
  name: "ModalEventReservations",
  props: ["inputModalData"],
  components: {
    ModalSingleReservation: ModalSingleReservation,
    ModalQuickLock: ModalQuickLock,
    ModalQuickShowWhoLockedTable: ModalQuickShowWhoLockedTable,
    ModalQuickSwapReservations: ModalQuickSwapReservations,
    ModalQuickCheckin: ModalQuickCheckin
  },
  // firebase: function () {
  //   return {
  //     listOfAllVenues: {
  //       source: firebaseDB.ref('listOfVenues'),
  //       asObject: true,
  //       // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
  //       //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
  //       // this is called once the data has been retrieved from firebase
  //       readyCallback: function (dataSnapshot) {
  //         this.formVars.eventVenue.isLoading.pop();
  //         //once we have list of all access levels, we can update 'selected option' to be one that user has
  //         dataSnapshot.forEach(function(dataSnapshot) {
  //             var item = dataSnapshot.val();
  //             item.key = dataSnapshot.key;
  //             this.tempListOfAllVenues[item.key] = item;
  //         }.bind(this));
  //       }
  //     },
  //     listOfCurrencyUnits: {
  //       source: firebaseDB.ref('listOfCurrencyUnits'),
  //       //asObject: true,
  //       // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
  //       //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
  //       // this is called once the data has been retrieved from firebase
  //       readyCallback: function (dataSnapshot) {
  //         //this.formVars.eventVenue.isLoading.pop();
  //         //once we have list of all access levels, we can update 'selected option' to be one that user has
  //         //this.setSelectedAccessLevelFromUser(dataSnapshot);
  //       }
  //     }
  //   }
  // },
  data() {
    return {
      msg: "ModalEventReservations modal",
      isLoading: [1],
      expandedOptionsIndex: null,
      eventBasicInfo: null,
      eventReservationsList: null,
      listOfReservationsForEvent: null,
      // status rezervacije (waiting:1=Ceka se gost da dodje, arrived:2=Gost je dosao, notArrived:3=Gost nije dosao), koristi se da se zna da li je gost dosao ili je ispalio
      tableStatusEnums: null,
      resolve: null,
      reject: null,
      // ~ received object of event that we want to show
      eventObject: null,
      // ~ for showing modal
      modalComponent: {
        isVisible: false,
        activeModalComponent: null,
        dataForModal: null
      },
      reservationsImage: {
        isVisible: false,
        imgUrl: ""
      }
    };
  },
  methods: {
    toggleExpandReservationButtonOptions: function(inputReservationUid) {
      if (this.expandedOptionsIndex == inputReservationUid) {
        this.expandedOptionsIndex = null;
      } else {
        this.expandedOptionsIndex = inputReservationUid;
      }
    },
    // calculate should user have edit button option if some reservation is locked
    calculateUserEditPermision: function(inputReservationItem) {
      var returnVisibilityState = true;
      if (
        inputReservationItem &&
        inputReservationItem.tableLocked &&
        inputReservationItem.tableLocked.status === true &&
        inputReservationItem.tableLocked.lockedByUserUid
      ) {
        if (
          this.currentFirebaseUser &&
          this.currentFirebaseUser.currentUser &&
          this.currentFirebaseUser.currentUser.uid &&
          this.currentFirebaseUser.currentUser.uid ==
            inputReservationItem.tableLocked.lockedByUserUid
        ) {
          returnVisibilityState = true;
        } else {
          returnVisibilityState = false;
        }
      }
      ///
      return returnVisibilityState;
    },
    // ~ call api to get list of all Future Events
    // getWantedEventData: function () {
    //   // ToDo - Create API CALLS
    //   if (DummyData.nemanjaRadonjic.table){
    //     this.eventObject = {};
    //     this.eventObject.eventInfo = this.inputModalData.dataForModal;
    //     this.eventObject.listOfTables = DummyData.nemanjaRadonjic.table;
    //   }
    // },
    ///~
    getAllReservationsForEvent: function(inputThisEventUid) {
      //console.log('inputThisEventUid: ' + inputThisEventUid);
      var starCountRef = firebaseDB.ref(
        "listOfAllEventsReservations/" + inputThisEventUid
      );
      starCountRef.on(
        "value",
        function(snapshot) {
          //console.log('Read Res list SUCCESS>> ');
          //console.log('snapshot.val(): ' + JSON.stringiPfy(snapshot.val(), null, 2));
          //this.listOfReservationsForEvent = snapshot.val();
          /* new code with filtered order */
          let tempEntireList = snapshot.val();
          let onlyPrimaryTables = {};
          let onlyGalleryAndBarTables = {};
          console.log(tempEntireList);
          console.log("starting");
          for (var item in tempEntireList) {
            if (tempEntireList.hasOwnProperty(item)) {
              console.log('has each key: ' + item)
              console.log(item)
              if (tempEntireList[item].tableShortName && (tempEntireList[item].tableShortName == 'B' || tempEntireList[item].tableShortName == 'G') ){
                onlyGalleryAndBarTables[item] = tempEntireList[item];
              }else{
                onlyPrimaryTables[item] = tempEntireList[item];
              }
            }
          }
          console.log("onlyGalleryAndBarTables>>")
          console.log(onlyGalleryAndBarTables)
          console.log("onlyPrimaryTables>>")
          console.log(onlyPrimaryTables)          
          this.listOfReservationsForEvent = Object.assign({}, onlyPrimaryTables, onlyGalleryAndBarTables);
          //debugger;
          console.log("ending");
          console.log(this.listOfReservationsForEvent)
          //We must check if reservation type

          /* example from Future Events
    monthFilteredListOfEvents: function() {
      if (!this.selectedMonthFilter) {
        return this.listOfFutureEvents;
      } else {
        return this.listOfFutureEvents.filter(eventItem => {
          if (eventItem.eventDate) {
            var eventMonth = moment(eventItem.eventDate).format("MMMM, YYYY");
            if (eventMonth === this.selectedMonthFilter) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        });
      }
    }         
         */
          setTimeout(
            function() {
              this.isLoading.pop();
            }.bind(this),
            200
          );
        }.bind(this)
      );
      // firebaseDB.ref().child('listOfAllEventsReservations/' + inputThisEventUid).on('value', function(snapshot){
      //   console.log('Read Res list SUCCESS>> ');
      //   console.log('snapshot.val(): ' + JSON.stringify(snapshot.val(), null, 2));
      // });
      // firebaseDB.ref().child('listOfAllEventsReservations/' + inputThisEventUid).on('value').then(
      //   function (response) {
      //     console.log('Read Res list SUCCESS: ' + JSON.stringify(response, null, 2));
      //   }.bind(this),
      //   function (error){
      //     console.log('Read Res list ERROR: ' + JSON.stringify(error, null, 2));
      //   }.bind(this)
      // );
    },
    // ~ When we want to save changes created on this modal
    saveChanges: function() {
      var resultToReturn = {
        tempMsg: "ModalEventReservations returns Yes"
      };
      this.resolve(resultToReturn);
    },
    // ~ When we want to discard changes
    cancelChanges: function() {
      this.reject();
    },
    /* #region Show Single Reservation Details Modal */
    // ~ when user wants to change Reservations for some event
    openReservationDetails: function(inputReservationItem) {
      //console.log('open single reservatio details modal');
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_SingleReservationDetails(
        inputReservationItem
      ).then(
        function(response) {
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_SingleReservationDetails: function(inputReservationItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalSingleReservation;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Reservations Title",
          dataForModal: {
            selectedReservationItem: inputReservationItem,
            eventReservationsKey: this.eventBasicInfo.eventReservationsKey
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Show Single Reservation Details Modal */
    /* #region Checkin Status Modal */
    // ~ when user wants to change Reservations for some event
    openCheckinStatus: function(inputReservationItem) {
      //console.log('open single reservatio details modal');
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_CheckinStatus(
        inputReservationItem
      ).then(
        function(response) {
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_CheckinStatus: function(inputReservationItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalQuickCheckin;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Reservations Title",
          dataForModal: {
            selectedReservationItem: inputReservationItem,
            tableStatusEnums: this.inputModalData.dataForModal.tableStatusEnums,
            eventUid: this.eventBasicInfo.eventReservationsKey
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Checkin Status Modal */
    /* #region Switch Tables Modal */
    openSwapReservations: function(inputReservationItem) {
      //console.log('open single reservatio details modal');
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_SwapReservations(
        inputReservationItem
      ).then(
        function(response) {
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_SwapReservations: function(inputReservationItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalQuickSwapReservations;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Reservations Title",
          dataForModal: {
            selectedReservationItem: inputReservationItem,
            eventReservationsKey: this.eventBasicInfo.eventReservationsKey
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Switch Tables Modal */
    /* #region Switch Tables Modal */
    openLockTable: function(inputReservationItem) {
      //console.log('open single reservatio details modal');
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_LockTable(
        inputReservationItem
      ).then(
        function(response) {
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_LockTable: function(inputReservationItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalQuickLock;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Reservations Title",
          dataForModal: {
            selectedReservationItem: inputReservationItem,
            eventUid: this.eventBasicInfo.eventReservationsKey,
            currentFirebaseUser: this.currentFirebaseUser
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Switch Tables Modal */
    /* #region Show Who Locked Table Modal */
    showWhoLockedTable: function(inputReservationItem) {
      //console.log('open single reservatio details modal');
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_ShowWhoLockedTable(
        inputReservationItem
      ).then(
        function(response) {
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_ShowWhoLockedTable: function(inputReservationItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalQuickShowWhoLockedTable;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Reservations Title",
          dataForModal: inputReservationItem,
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Show Who Locked Table Modal */
    closeModal: function() {
      this.modalComponent.isVisible = false;
      this.modalComponent.activeModalComponent = null;
      this.modalComponent.dataForModal = null;
      this.expandedOptionsIndex = null;
    },
    returnEventDayOfWeek: function(inputEventObject) {
      var returnValue = "Nedefinisan";
      if (inputEventObject && inputEventObject.eventDate) {
        returnValue = moment(inputEventObject.eventDate).format("dddd");
      }
      return returnValue;
    },
    returnEventDate_fullDate: function(inputEventObject) {
      var returnDate = "Nedefinisan";
      if (inputEventObject && inputEventObject.eventDate) {
        returnDate = moment(inputEventObject.eventDate).format(
          "DD. MMMM YYYY."
        );
      }
      //
      return returnDate;
    },
    returnCurrencyType: function(inputEventObject) {
      var returnValue = "--";
      if (
        inputEventObject &&
        inputEventObject.ticketPriceCurrency &&
        this.tempListOfCurrencyUnits
      ) {
        for (var key in this.tempListOfCurrencyUnits) {
          if (this.tempListOfCurrencyUnits.hasOwnProperty(key)) {
            if (
              key == inputEventObject.ticketPriceCurrency &&
              this.tempListOfCurrencyUnits[key].title
            ) {
              //console.log('name is this: ' + this.tempListOfAllVenues[key].name);
              returnValue = this.tempListOfCurrencyUnits[key].title;
            }
          }
        }
      }
      return returnValue;
    },
    returnEventVenue_type: function(inputEventObject) {
      var returnValue = "Nedefinisan";
      if (inputEventObject && inputEventObject.eventVenue) {
        //console.log('this.tempListOfAllVenues: ' + JSON.stringify(this.tempListOfAllVenues, null, 2) );
        for (var key in this.tempListOfAllVenues) {
          if (this.tempListOfAllVenues.hasOwnProperty(key)) {
            if (
              key == inputEventObject.eventVenue &&
              this.tempListOfAllVenues[key].name
            ) {
              //console.log('name is this: ' + this.tempListOfAllVenues[key].name);
              returnValue = this.tempListOfAllVenues[key].name;
            }
          }
        }
      }
      return returnValue;
    },
    ///
    returnTableCheckinClass: function(inputTableObject) {
      var returnClass = "";
      if (
        inputTableObject &&
        (inputTableObject.guestFirstName ||
          inputTableObject.guestLastName ||
          inputTableObject.guestNickname)
      ) {
        returnClass = "c-status-is-waiting";
        if (
          inputTableObject.tableCheckedInStatus &&
          inputTableObject.tableCheckedInStatus ==
            this.tableStatusEnums.notArrived
        ) {
          returnClass = "c-status-is-canceled";
        }
        if (
          inputTableObject.tableCheckedInStatus &&
          inputTableObject.tableCheckedInStatus == this.tableStatusEnums.arrived
        ) {
          returnClass = "c-status-is-checked";
        }
      }
      //
      return returnClass;
    },
    //
    calculateIfTableIsLocked: function(inputTableObject) {
      var returnValue = false;
      if (
        inputTableObject &&
        inputTableObject.tableLocked &&
        inputTableObject.tableLocked.lockedByUserUid
      ) {
        returnValue = true;
      }
      return returnValue;
    },
    //
    checkLockTableStatus: function(inputTableObject) {
      // if (this.currentFirebaseUser && this.currentFirebaseUser.currentUser && this.currentFirebaseUser.currentUser.uid && this.currentFirebaseUser.currentUser.uid == inputReservationItem.tableLocked.lockedByUserUid){
      //   returnVisibilityState = true;
      // }else{
      //   returnVisibilityState = false;
      // }
      if (
        this.currentFirebaseUser &&
        this.currentFirebaseUser.currentUser &&
        this.currentFirebaseUser.currentUser.uid &&
        inputTableObject.tableLocked.lockedByUserUid &&
        inputTableObject.tableLocked.lockedByUserUid ==
          this.currentFirebaseUser.currentUser.uid
      ) {
        this.openLockTable(inputTableObject);
      } else {
        this.showWhoLockedTable(inputTableObject);
      }
    },
    //show blueprint for tables (show how tables are organized)
    toggleReservationsPlan: function() {
      this.reservationsImage.imgUrl = require("@/assets/img/" +
        this.eventBasicInfo.eventVenue +
        ".jpg");
      //console.log('this.eventBasicInfo: ' + JSON.stringify(this.eventBasicInfo, null, 2) );
      this.reservationsImage.isVisible = !this.reservationsImage.isVisible;
    }
  },
  beforeCreate() {
    console.log("beforeCreate............");
    // if (this.inputModalData.dataForModal.eventReservationsKey){
    //   this.eventBasicInfo.eventReservationsKey = this.inputModalData.dataForModal.eventReservationsKey;
    //   console.log('.....this.linkedReservationsKeythis.eventBasicInfo.eventReservationsKey: ' + this.eventBasicInfo.eventReservationsKey);
    // }
  },
  created() {
    //console.log('~ created- ModalEventReservations component!');
    if (this.inputModalData) {
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      // if (this.inputModalData.dataForModal.eventReservationsKey){
      //   this.eventBasicInfo = this.inputModalData.dataForModal;
      //   //this.$bindAsArray('listOfReservationsForEvent', firebaseDB.ref('listOfAllEventsReservations/' + this.eventBasicInfo.eventReservationsKey) );
      // }
      if (
        this.inputModalData.dataForModal &&
        this.inputModalData.dataForModal.selectedEventObject
      ) {
        this.eventBasicInfo = this.inputModalData.dataForModal.selectedEventObject;
        this.getAllReservationsForEvent(
          this.eventBasicInfo.eventReservationsKey
        );
      }
      if (
        this.inputModalData.dataForModal &&
        this.inputModalData.dataForModal.listOfVenueTypes
      ) {
        this.tempListOfAllVenues = this.inputModalData.dataForModal.listOfVenueTypes;
      }
      if (
        this.inputModalData.dataForModal &&
        this.inputModalData.dataForModal.listOfCurrencyUnits
      ) {
        this.tempListOfCurrencyUnits = this.inputModalData.dataForModal.listOfCurrencyUnits;
      }
      if (
        this.inputModalData.dataForModal &&
        this.inputModalData.dataForModal.tableStatusEnums
      ) {
        this.tableStatusEnums = this.inputModalData.dataForModal.tableStatusEnums;
      }
      if (
        this.inputModalData.dataForModal &&
        this.inputModalData.dataForModal.currentFirebaseUser
      ) {
        this.currentFirebaseUser = this.inputModalData.dataForModal.currentFirebaseUser;
        //console.log('this.currentFirebaseUser: ' + JSON.stringify(this.currentFirebaseUser, null, 2) );
      }
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
      //
      //this.getWantedEventData();
    }
  },
  mounted() {
    //console.log('~ mounted - ModalEventReservations component!');
  },
  destroyed() {
    //console.log('~ destroyed- ModalEventReservations component!');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/ModalEventReservations.vue